


  document.addEventListener("DOMContentLoaded", () => {


  const ajaxForms = document.querySelectorAll("ajax-cart-product-form form");
        const addButton = document.querySelector('.add-to-cart-btn');

initAjaxForms();
  function initAjaxForms() {
    ajaxForms.forEach(form => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (addButton) {
            addButton.disabled = true;
            addButton.classList.add('opacity-50', 'cursor-not-allowed'); // optional: style as disabled
        }
        const formData = new FormData(form);

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Accept": "application/json"
            },
            body: formData
          });

          if (!response.ok) throw new Error("Error adding product");

          const item = await response.json();

          await refreshCartDrawer();
        } catch (err) {
          console.error("AJAX Cart Error:", err);
          alert("Failed to add item. Please try again.");
        }
      });
    });
  }
  
  /* ---------------------------
   * REFRESH CART DRAWER SECTION
   * ------------------------ */
async function refreshCartDrawer() {
  const res = await fetch('/?sections=cart-items,cart-footer,cart-item-count');
  const sections = await res.json();

  // Cart items
  const itemsWrapper = document.querySelector('[data-cart-items]');
  if (itemsWrapper && sections['cart-items']) {
    itemsWrapper.innerHTML = sections['cart-items'];
  }

  // Cart footer (subtotal, checkout)
  const footerWrapper = document.querySelector('[data-cart-footer]');
  if (footerWrapper && sections['cart-footer']) {
    footerWrapper.innerHTML = sections['cart-footer'];
  }

  // 2️⃣ Fetch cart JSON (for count)
  const cart = await fetch('/cart.js').then(r => r.json());

  // 3️⃣ Update Alpine store
  if (window.Alpine && Alpine.store('cart_count')) {
    Alpine.store('cart_count').count = cart.item_count;
  }

  // 4️⃣ Re-init Alpine (only for replaced DOM)
  if (window.Alpine) {
    Alpine.initTree(document.body);
  }
  document.querySelector('#CartButton')?.click();
 
    // Re-enable button
    addButton.disabled = false;
    addButton.classList.remove('opacity-50', 'cursor-not-allowed');
}



});
